import { render, staticRenderFns } from "./RtnInvoiceEdit_Details2.vue?vue&type=template&id=3431d5d4&"
import script from "./RtnInvoiceEdit_Details2.vue?vue&type=script&lang=js&"
export * from "./RtnInvoiceEdit_Details2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports